import React from "react";

function ReturnAndRefundPolicy() {
  return (
    <div className="container my-5">
      <div className="col-12 d-flex justify-content-center">
        <h3 className="underline">Return, Refund & Cancellation Policy</h3>
      </div>

      <p className="text-center mt-2">
        At NRCB e-Banana Store, we take pride in delivering high-quality and
        freshly prepared banana-based products to our customers. Your
        satisfaction is our priority, and we aim to ensure that every order
        reaches you in perfect condition. Please read the following policy
        carefully before placing your order.
      </p>
      <section className="mt-4">
        <h6>Return Policy</h6>
        <ul className="mt-2">
          <li>
            Due to the perishable nature of food products, we regret that we
            cannot accept returns once an order has been shipped. However, we
            stand firmly behind the quality, freshness, and integrity of our
            products.
          </li>
          <li>
            If you receive a damaged, defective, or incorrect item, please
            contact our customer service team within 24 hours of delivery.
            Kindly share detailed information and, if possible, photographic
            evidence of the issue to help us assess and resolve it promptly.
          </li>
        </ul>
      </section>

      <section className="mt-4">
        <h6>Refund Policy</h6>
        <ul className="mt-2">
          <li>
            If your order arrives damaged, or you receive an incorrect product,
            we will gladly offer a replacement or refund for the affected items.
          </li>
          <li>To initiate a refund or replacement:</li>
          <li>
            Contact us at customercare{" "}
            <a href="mailto:NRCBebananastore@gmail.com">
              NRCBebananastore@gmail.com
            </a>{" "}
            within 24 hours of receiving your order.
          </li>
          <li>
            Provide proof of purchase and, where applicable, supporting images
            of the damaged or incorrect items.
          </li>
          <li>
            Upon approval, refunds will be processed to your original method of
            payment within 7 business days.
          </li>
          <li>
            Please note that the time taken for the refund to reflect in your
            account may vary depending on your bank or payment gateway.
          </li>
          <li>
            All refunds are subject to verification and approval by our quality
            assurance team.
          </li>
        </ul>
      </section>

      <section className="mt-4">
        <h6>Cancellation Policy</h6>
        <ul className="mt-2">
          <li>
            Orders can be cancelled for a full refund if the request is made
            before the dispatch.
          </li>
          <li>
            Once an order has been shipped, cancellations or modifications
            cannot be accommodated.
          </li>
          <li>
            To cancel your order, please contact our support team immediately at
            customercare{" "}
            <a href="mailto:NRCBebananastore@gmail.com">
              NRCBebananastore@gmail.com
            </a>{" "}
            with your order details.
          </li>
        </ul>
      </section>
      <section className="mt-4">
        <h6>Additional Notes</h6>
        <ul className="mt-2">
          <li>Shipping charges, if applicable, are non-refundable.</li>
          <li>
            Refunds or replacements will not apply to products stored improperly
            after delivery.
          </li>
        </ul>
        <p>
          We reserve the right to deny refund requests if the product is found
          to have been tampered with or mishandled after receipt.
        </p>
      </section>
      <section className="mt-4">
        <h6>Contact Us</h6>
        <p>
          For any queries or assistance regarding your order, please contact:{" "}
        </p>
        <p>
          <a href="mailto:NRCBebananastore@gmail.com">
            NRCBebananastore@gmail.com
          </a>
        </p>
      </section>
      <section className="mt-4">
        <p>
          We sincerely value your trust and continued support. Thank you for
          choosing{" "}
          <a href="https://nrcbe-bananastore.com/" target="blank">
            NRCB e-Banana Store
          </a>{" "}
          — where quality, authenticity, and freshness are our promise.
        </p>
      </section>
    </div>
  );
}

export default ReturnAndRefundPolicy;
